@use '@design/components/custom-scroll/custom-scroll' as *;

.legendPositionRoot {
  @include custom-scroll-minimal;
  overflow-y: scroll;
  max-height: 400px;
  position: absolute;
  left: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
